import { render } from "./StandardContentIndex.vue?vue&type=template&id=d1d88576&scoped=true"
import script from "./StandardContentIndex.vue?vue&type=script&lang=js"
export * from "./StandardContentIndex.vue?vue&type=script&lang=js"

import "./StandardContentIndex.vue?vue&type=style&index=0&id=d1d88576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d88576"]])

export default __exports__